import React from 'react';

const ShareIcon = () => (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="invite-icon">
        <path d="M7 8C9.20914 8 11 6.20914 11 4C11 1.79086 9.20914 0 7 0C4.79086 0 3 1.79086 3 4C3 6.20914 4.79086 8 7 8Z" fill="white"/>
        <path d="M7.00019 9C1.12778 9 0 12.2918 0 13.3477C0 14.4021 0.765087 15 1.47969 15H7.00019H12.5205C13.2347 15 14 14.4025 14 13.3477C14 12.2918 12.8722 9 7.00019 9Z" fill="white"/>
        <path d="M19.3042 6.80448H17.1953V4.69576C17.1953 4.31098 16.8843 4 16.5 4C16.1155 4 15.8042 4.31098 15.8042 4.69576V6.80448H13.6955C13.3112 6.80448 13 7.11546 13 7.5C13 7.88431 13.3112 8.19576 13.6955 8.19576H15.8042V10.3042C15.8042 10.6883 16.1155 11 16.5 11C16.8843 11 17.1953 10.6883 17.1953 10.3042V8.19576H19.3042C19.6888 8.19576 20 7.88431 20 7.5C20 7.11546 19.6888 6.80448 19.3042 6.80448Z" fill="white"/>
    </svg>
);

export default ShareIcon;
